module.exports = __webpack_public_path__ + "static/media/akagi-icon.007b9526.png";